let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4XrNU")).then(() => parcelRequire('62BDU'));